import './SettingsView.css';

function SettingsView() {
  return <div className="settings-view">settings</div>;
}

export default SettingsView;
